import { render, staticRenderFns } from "./jigang.vue?vue&type=template&id=802905f8&scoped=true&"
import script from "./jigang.vue?vue&type=script&lang=js&"
export * from "./jigang.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=802905f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802905f8",
  null
  
)

export default component.exports